import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';

import getImageUrl from '../../services/get-image-url';
import { isInSite } from '../../services/view-mode';
import { getForumTitle } from '../../selectors/forum-data-selectors';
import Wix from '../../services/wix-sdk-polyfill';

const MAX_DESCRIPTION_LENGTH = 160;

const getMetaCategories = ({ title, description, image, type, noIndex }) => {
  const metaCategories = [
    {
      property: 'og:title',
      content: title,
    },
    {
      name: 'description',
      content: description,
    },
    {
      property: 'og:description',
      content: description.slice(0, MAX_DESCRIPTION_LENGTH),
    },
    {
      property: 'og:type',
      content: type,
    },
  ];

  if (image) {
    metaCategories.push({
      property: 'og:image',
      content: getImageUrl(image),
    });
    metaCategories.push({
      property: 'og:image:width',
      content: image.width,
    });
    metaCategories.push({
      property: 'og:image:height',
      content: image.height,
    });
  }

  if (noIndex) {
    metaCategories.push({
      name: 'robots',
      content: 'noindex',
    });
  }

  return metaCategories;
};

export const PageMetadata = ({ title, description, image, type, noIndex }) =>
  <Helmet
    title={title}
    meta={getMetaCategories({ title, description, image, type, noIndex })}
    onChangeClientState={() => {
      try {
        if (isInSite()) {
          Wix.setPageMetadata({ title, description });
        }
      } catch (e) {
        console.error(e);
      }
    }}
  />;

PageMetadata.propTypes = {
  title: PropTypes.string,
  type: PropTypes.string,
  description: PropTypes.string,
  image: PropTypes.object,
  noIndex: PropTypes.bool,
};

PageMetadata.defaultProps = {
  title: '',
  description: '',
  type: 'website',
};

const mapStateToProps = (state, ownProps) => {
  const forumTitle = getForumTitle(state);
  return {
    title: ownProps.title ? `${ownProps.title} | ${forumTitle}` : forumTitle,
  };
};

export default connect(mapStateToProps)(PageMetadata);



// WEBPACK FOOTER //
// ./app/components/page-metadata/page-metadata.js